import Spin from 'components/Spin'

const LoadingSpin = ({ className }) => (
  <div className={`flex justify-center my-20 ${className}`}>
    <Spin color="text-blue" size="10" className="my-2 lg:my-8" />
  </div>
)

export default LoadingSpin
